<template>
  <base-modal>
    <z-form ref="form" @submit.native.prevent="submit">
      <p>{{ $t('mailer.sender.modal.add.description') }}</p>

      <z-form-group>
        <div>
          {{ $t('mailer.sender.modal.add.sender_name') }}
        </div>

        <z-form-input
          :rules="{ latin_num_ext: true, required: true, max: 11 }"
          :show_errors="true"
          vid="name"
        >
          <i-input v-model="form.name" style="width: 95%" />
          <tooltip
            class="ml-3 w-250 pos-a"
            placement="top"
            max-width="300"
            theme="light"
            :content="$t('mailer.sender.form.create.description')"
          >
            <icon size="18" type="ios-help-circle-outline" />
          </tooltip>
        </z-form-input>
      </z-form-group>
    </z-form>

    <i-button slot="footer-ok" type="success" size="large" :loading="loading" @click="save">
      {{ $t('shared.component.button.request') }}
    </i-button>
  </base-modal>
</template>

<script>
  import { PageServerValidationResponseMixin } from '@shared/mixins/page-server-validation-response';
  import { SenderService } from '@mailer/services/SenderService';
  import { mapActions } from 'vuex';
  import { PRICE_TYPE_SMS } from '@utils/services';
  import BaseModal from '@shared/components/modal/modal';

  export default {
    components: {
      BaseModal
    },
    mixins: [PageServerValidationResponseMixin],
    data: () => ({
      form: {
        name: '',
        type: PRICE_TYPE_SMS
      },
      loading: false
    }),

    methods: {
      ...mapActions('mailer/senders/table', ['getAsyncData']),

      save() {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            this.loading = true;

            SenderService.createItem(this.form)
              .then((res) => this.$emit('success', res))
              .catch((e) => {
                this.$emit('fail', e?.response?.data?.name)
              })
              .finally(() => (this.loading = false));
          }
        });
      }
    }
  };
</script>

<style lang="scss">
  .w-250 {
    .ivu-tooltip-inner {
      min-width: 250px;
    }
  }
  .pos-a {
    position: absolute;
    top: 5px;
    right: -15px;
  }
</style>
